export default "__VITE_ASSET__84e9f7d6__"